import { resolveUserDisplayName } from '../query/normalize-audit-row';

export function deriveUser(row) {
  return { display: resolveUserDisplayName(row), source: userSource(row) };
}

function userSource({ userName, userEmail }) {
  if (userName) return 'name';
  if (userEmail) return 'email';
  return 'id';
}
